import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class SceneList {

    getSceneLists(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/scenelists',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getSceneList(token, scenelistID) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/scenelists/' + scenelistID,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


    postSceneList(token, data) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/scenelists',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putSceneList(token, scenelistID, data) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/scenelists/' + scenelistID,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteSceneList(token, scenelistID) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/scenelists/' + scenelistID,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}